import { createFileRoute, notFound } from "@tanstack/react-router";

import { VenueDialog } from "../features/venues/components/VenueDialog";
import { venueQueries } from "../features/venues/api/queries";
import { areaQueries } from "../features/weather/api/queries";
import { AppHeader } from "../shared/ui/AppHeader";

export const Route = createFileRoute("/_authenticated/venues/$venueId/edit")({
  loader: async ({ params, context: { queryClient } }) => {
    /*
     * No detail query: `venues` already returns every field the form needs, and
     * the dialog re-reads the row from that list so the links editor's
     * invalidations show up. Fetching one venue separately would put the same
     * row in two caches, and only one of them would update.
     */
    const [data] = await Promise.all([
      queryClient.ensureQueryData(venueQueries.list()),
      queryClient.ensureQueryData(areaQueries.list()),
    ]);
    if (!data.venues.some((venue) => venue.id === params.venueId)) {
      throw notFound();
    }
  },
  component: EditVenuePage,
});

/** Chrome behind the modal; the dialog owns the form. */
function EditVenuePage() {
  const { venueId } = Route.useParams();

  return (
    <>
      <AppHeader />
      <VenueDialog venueId={venueId} />
    </>
  );
}
